import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import globalBeforeEachGuard from './guard'

export const routesWithoutHeader = [
  'Login',
  'SignUp',
  'ResetPassword',
  'PasswordRecover',
  'SocialAuthSuccess',
  'SocialAuthFailed',
  'PaymentSuccess',
  'PaymentFailed',
  'Unauthorized'
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(globalBeforeEachGuard)

export default router
